import { forwardRef } from "react";
import styles from "./Button.module.css";

const Button = forwardRef(
  (
    {
      children,
      variant = "primary",
      size = "md",
      type = "button",
      loading = false,
      disabled = false,
      fullWidth = false,
      icon,
      trailIcon,
      className = "",
      onClick,
      ...rest
    },
    ref
  ) => {
    const isDisabled = loading || disabled;

    const btnClass = [
      styles.button,
      styles[variant] || styles.primary,
      styles[size] || styles.md,
      fullWidth ? styles.fullWidth : "",
      isDisabled ? styles.disabled : "",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <button
        ref={ref}
        type={type}
        className={btnClass}
        disabled={isDisabled}
        onClick={onClick}
        {...rest}
      >
        {loading ? (
          <>
            <span className={styles.spinner} aria-hidden="true" />
            <span>{children}</span>
          </>
        ) : (
          <>
            {icon && <span aria-hidden="true">{icon}</span>}
            <span>{children}</span>
            {trailIcon && <span aria-hidden="true">{trailIcon}</span>}
          </>
        )}
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
